<script>
import ErrorUtils from './../helpers/ErrorUtils.js';
import { mapGetters } from 'vuex';

export default {
  name: 'reservation-form-helpers',
  computed: {
    ...mapGetters({
      cartIsWaitingForDecision: 'global/cartIsWaitingForDecision'
    })
  },
  methods: {
    accept () {
      this.acceptInProgress = true;

      this.$http.post('/panel/general/set-inquiry-status', {
        id: this.reservationData.id,
        status: !this.isReservation ? 2 : 3
      }).then(response => {
        this.acceptInProgress = false;

        if (response.data.result === 0) {
          if (response.data.worker_error === 1) {
            if (response.data.free_workers.length > 0) {
              this.$bus.$emit('reservation-rules-problem-display', {
                type: 'free-workers',
                workers: response.data.free_workers,
                okClick: (workerID) => this.acceptWithWorker(workerID),
                cancelClick: this.reject
              });
            } else {
              this.$bus.$emit('reservation-rules-problem-display', {
                type: 'no-free-workers',
                okClick: () => this.$router.push('/reservation/edit/' + this.reservationData.id),
                cancelClick: this.reject
              });
            }
          } else {
            this.$bus.$emit('reservation-rules-problem-display', {
              type: 'other-rules',
              message: response.data.error,
              okClick: () => this.$router.push('/reservation/edit/' + this.reservationData.id),
              cancelClick: this.reject
            });
          }

          this.$bus.$emit('reservation-details-popup-reload-needed');
        } else {
          this.updateInquiriesList(3);
          this.$bus.$emit('notification-display', {
            type: 'success',
            message: this.$t('reservationStatusChange.reservationAccepted')
          });

          this.$bus.$emit('reservation-details-popup-reload-needed');
        }
      }).catch(error => {
        ErrorUtils.handleSubmitError(error, '/panel/general/set-inquiry-status', this.$router, this.$bus, this.accept.bind(this));
        this.acceptInProgress = false;
        this.$bus.$emit('reservation-details-popup-reload-needed');
      });
    },
    acceptWithWorker (workerID) {
      this.acceptInProgress = true;

      this.$http.post('/panel/general/set-inquiry-status', {
        id: this.reservationData.id,
        status: !this.isReservation ? 2 : 3,
        worker_id: workerID
      }).then(response => {
        this.acceptInProgress = false;

        if (response.data.result === 0) {
          if (response.data.worker_error === 1) {
            if (response.data.free_workers.length > 0) {
              this.$bus.$emit('reservation-rules-problem-display', {
                type: 'free-workers',
                workers: response.data.free_workers,
                okClick: (workerID) => this.acceptWithWorker(workerID),
                cancelClick: this.reject
              });
            } else {
              this.$bus.$emit('reservation-rules-problem-display', {
                type: 'no-free-workers',
                okClick: () => this.$router.push('/reservation/edit/' + this.reservationData.id),
                cancelClick: this.reject
              });
            }
          } else {
            this.$bus.$emit('reservation-rules-problem-display', {
              type: 'other-rules',
              message: response.data.error,
              okClick: () => this.$router.push('/reservation/edit/' + this.reservationData.id),
              cancelClick: this.reject
            });
          }

          this.$bus.$emit('reservation-details-popup-reload-needed');
        } else {
          this.updateInquiriesList(3);
          this.$bus.$emit('notification-display', {
            type: 'success',
            message: this.$t('reservationStatusChange.reservationAccepted')
          });

          this.$bus.$emit('reservation-details-popup-reload-needed');
        }
      }).catch(error => {
        ErrorUtils.handleSubmitError(error, '/panel/general/set-inquiry-status', this.$router, this.$bus, this.acceptWithWorker.bind(this, workerID));
        this.acceptInProgress = false;
        this.$bus.$emit('reservation-details-popup-reload-needed');
      });
    },
    reject () {
      if (this.isCyclic) {
        if (!this.isReservation) {
          if (this.$store.state.config.company.waiting_list) {
            this.$bus.$emit('confirm-display', {
              title: this.$t('reservationStatusChange.requestRejectedWithWaitingListTitle'),
              desc: this.$t('reservationStatusChange.requestRejectedWithWaitingListDesc'),
              cancelLabel: this.$t('reservationStatusChange.requestRejectedWithWaitingListCancelButton'),
              cancelClick: (notifyUser) => this.rejectNonReservationInquiry(4, true, notifyUser),
              okLabel: this.$t('reservationStatusChange.requestRejectedWithWaitingListOkButton'),
              okClick: (notifyUser) => this.rejectNonReservationInquiry(6, true, notifyUser),
              checkbox: true,
              checkboxLabel: this.$t('reservationForm.notifyClient'),
              checkboxDefaultValue: true
            });
          } else {
            this.$bus.$emit('confirm-display', {
              title: this.$t('reservationStatusChange.requestRejectedTitle'),
              desc: this.$t('reservationStatusChange.requestRejectedDesc'),
              cancelLabel: this.$t('common.ui.close'),
              okLabel: this.$t('reservationStatusChange.rejectRequest'),
              okClick: (notifyUser) => this.rejectNonReservationInquiry(4, true, notifyUser),
              checkbox: true,
              checkboxLabel: this.$t('reservationForm.notifyClient'),
              checkboxDefaultValue: true
            });
          }
        } else {
          let confirmTitle = this.$t('reservationStatusChange.rejectReservationTitle');
          let confirmDesc = this.$t('reservationStatusChange.rejectCyclicReservation');
          let confirmCancelLabel = this.$t('reservationStatusChange.rejectAll');
          let confirmOkLabel = this.$t('reservationStatusChange.rejectOnlyThisOne');

          if (this.reservationData.status === 3) {
            confirmTitle = this.$t('reservationStatusChange.cancelReservationTitle');
            confirmDesc = this.$t('reservationStatusChange.cancelCyclicReservation');
            confirmCancelLabel = this.$t('reservationStatusChange.cancelAll');
            confirmOkLabel = this.$t('reservationStatusChange.cancelOnlyThisOne');
          }

          this.$bus.$emit('confirm-display', {
            title: confirmTitle,
            desc: confirmDesc,
            cancelLabel: confirmCancelLabel,
            cancelClick: (notifyUser) => {
              this.rejectInquiry(true, notifyUser)
            },
            okLabel: confirmOkLabel,
            okClick: (notifyUser) => {
              this.rejectInquiry(false, notifyUser)
            },
            closeButton: true,
            checkbox: true,
            checkboxLabel: this.$t('reservationForm.notifyClient'),
            checkboxDefaultValue: true
          });
        }
      } else {
        if (this.isReservation) {
          this.$bus.$emit('confirm-display', {
            title: this.$t('reservationStatusChange.cancelReservationTitle'),
            desc: this.$t('reservationStatusChange.doYouWantCancelReservation'),
            cancelLabel: this.$t('common.ui.close'),
            okLabel: this.$t('reservationStatusChange.cancelReservation'),
            okClick: (notifyUser) => this.rejectInquiry(false, notifyUser),
            checkbox: true,
            checkboxLabel: this.$t('reservationForm.notifyClient'),
            checkboxDefaultValue: true
          });
        } else {
          if (this.$store.state.config.company.waiting_list) {
            this.$bus.$emit('confirm-display', {
              title: this.$t('reservationStatusChange.requestRejectedWithWaitingListTitle'),
              desc: this.$t('reservationStatusChange.requestRejectedWithWaitingListDesc'),
              cancelLabel: this.$t('reservationStatusChange.requestRejectedWithWaitingListCancelButton'),
              cancelClick: (notifyUser) => this.rejectNonReservationInquiry(4, false, notifyUser),
              okLabel: this.$t('reservationStatusChange.requestRejectedWithWaitingListOkButton'),
              okClick: (notifyUser) => this.rejectNonReservationInquiry(6, false, notifyUser),
              checkbox: true,
              checkboxLabel: this.$t('reservationForm.notifyClient'),
              checkboxDefaultValue: true
            });
          } else {
            this.$bus.$emit('confirm-display', {
              title: this.$t('reservationStatusChange.requestRejectedTitle'),
              desc: this.$t('reservationStatusChange.requestRejectedDesc'),
              cancelLabel: this.$t('common.ui.close'),
              okLabel: this.$t('reservationStatusChange.rejectRequest'),
              okClick: (notifyUser) => this.rejectNonReservationInquiry(4, false, notifyUser),
              checkbox: true,
              checkboxLabel: this.$t('reservationForm.notifyClient'),
              checkboxDefaultValue: true
            });
          }
        }
      }
    },
    rejectNonReservationInquiry (nextStatus = 4, rejectFutureInquiries = false, notifyUser = false) {
      this.rejectInProgress = true;

      let configuration = {
        id: this.reservationData.id,
        status: nextStatus,
        notify_user: +notifyUser
      };

      if (rejectFutureInquiries) {
        configuration.periodicity = 1;
      }

      this.$http.post('/panel/general/set-inquiry-status', configuration).then(response => {
        this.updateInquiriesList(nextStatus);
        this.$bus.$emit('calendar-day-popup-reload-reservations');
        this.$bus.$emit('updated-reservation-status');
        this.$bus.$emit('reservation-details-popup-reload-needed');
        this.rejectInProgress = false;
      }).catch(error => {
        ErrorUtils.handleSubmitError(error, '/panel/general/set-inquiry-status', this.$router, this.$bus, this.rejectInquiry.bind(this, rejectFutureInquiries, notifyUser));
        this.rejectInProgress = false;
        this.$bus.$emit('reservation-details-popup-reload-needed');
      });
    },
    rejectInquiry (rejectFutureInquiries = false, notifyUser = false) {
      this.rejectInProgress = true;

      let configuration = {
        id: this.reservationData.id,
        status: this.isReservation ? 5 : 4,
        notify_user: +notifyUser
      };

      if (rejectFutureInquiries) {
        configuration.periodicity = 1;
      }

      this.$http.post('/panel/general/set-inquiry-status', configuration).then(response => {
        this.updateInquiriesList(4);
        this.checkReservationList();
        this.$bus.$emit('calendar-day-popup-reload-reservations');
        this.$bus.$emit('updated-reservation-status');
        this.$bus.$emit('reservation-details-popup-reload-needed');
        this.rejectInProgress = false;
      }).catch(error => {
        ErrorUtils.handleSubmitError(error, '/panel/general/set-inquiry-status', this.$router, this.$bus, this.rejectInquiry.bind(this, rejectFutureInquiries, notifyUser));
        this.rejectInProgress = false;
        this.$bus.$emit('reservation-details-popup-reload-needed');
      });
    },
    unblock (e) {
      e.stopPropagation();

      if (this.isCyclic) {
        this.$bus.$emit('confirm-display', {
          title: this.$t('reservationStatusChange.unblockDateTitle'),
          desc: this.$t('reservationStatusChange.unblockDateDesc'),
          cancelLabel: this.$t('reservationStatusChange.unblockDateCancelBtn'),
          cancelClick: this.unblockDate.bind(this, true),
          okLabel: this.$t('reservationStatusChange.unblockDateOkBtn'),
          okClick: this.unblockDate.bind(this, false),
          closeButton: true
        });

        this.unblockInProgress = false;
      } else {
        this.$bus.$emit('confirm-display', {
          title: this.$t('reservationStatusChange.unblockDate2Title'),
          desc: this.$t('reservationStatusChange.unblockDate2Desc'),
          cancelLabel: this.$t('common.ui.close'),
          okLabel: this.$t('reservationStatusChange.unblockDate2Btn'),
          okClick: this.unblockDate.bind(this, false)
        });
      }
    },
    unblockDate (rejectFutureBlockedDates = false) {
      this.unblockInProgress = true;

      let configuration = {
        id: this.reservationData.id
      };

      if (rejectFutureBlockedDates) {
        configuration.periodicity = 1;
      }

      this.$http.post('/panel/blocked-termins/unblock', configuration).then(response => {
        this.$store.commit('global/removeInquiry', this.reservationData.id);
        this.$bus.$emit('dashboard-reservations-list-reload-needed');
        this.$bus.$emit('calendar-day-popup-reload-reservations');
        this.$bus.$emit('updated-reservation-status');
        this.$bus.$emit('reservation-details-popup-reload-needed');
        this.finishUnblockProcess();
      }).catch(error => {
        this.unblockInProgress = false;

        if (!ErrorUtils.handleValidationError(error, '/panel/blocked-termins/unblock', this.$router, this.$bus)) {
          ErrorUtils.handleSubmitError(error, '/panel/blocked-termins/unblock', this.$router, this.$bus, this.unblockDate.bind(this, rejectFutureBlockedDates));
        }

        this.$bus.$emit('reservation-details-popup-reload-needed');
      });
    },
    checkReservationList () {
      if (this.$store.state.config.company.waiting_list && !this.$store.state.config.company.auto_waiting_list) {
        this.$http.post('/panel/reservations/get-reserve-list', {
          id: this.reservationData.id
        }).then(response => {
          if (!response.data.data || !response.data.data.length) {
            this.finishRejectionProcess();
          } else {
            let people = response.data.data.map(person => {
              let output = '<strong>' + person.name + '</strong>';

              if (person.phone) {
                output += ', ' + person.phone;
              }

              if (person.email) {
                output += ', ' + person.email;
              }

              return output;
            });
            let list = '<ul><li>' + people.join('</li><li>') + '</li></ul>';

            this.$bus.$emit('confirm-display', {
              title: this.$t('reservationStatusChange.youHaveWaitingList'),
              desc: this.$t('reservationStatusChange.notifyAboutFreeTerm') + '<br>' + list,
              cancelLabel: this.$t('common.ui.closeNotNotify'),
              cancelClick: this.finishRejectionProcess,
              okLabel: this.$t('reservationStatusChange.yesNotify'),
              okClick: this.notifyPeople.bind(this)
            });
          }
        }).catch(error => {
          ErrorUtils.handleSubmitError(error, '/panel/reservations/get-reserve-list', this.$router, this.$bus, this.checkReservationList.bind(this));
          this.finishRejectionProcess();
        });
      } else {
        this.finishRejectionProcess();
      }
    },
    finishRejectionProcess (sendNotifications = false) {
      let msg = this.$t('reservationStatusChange.reservationRejected');

      if (sendNotifications) {
        msg = this.$t('reservationStatusChange.reservationRejectedNotificationsSent');
      }

      if (this.reservationData.status === 3) {
        msg = this.$t('reservationStatusChange.reservationCancelled');

        if (sendNotifications) {
          msg = this.$t('reservationStatusChange.reservationCancelledNotificationsSent');
        }
      }

      this.rejectInProgress = false;
      this.$bus.$emit('notification-display', {
        type: 'success',
        message: msg
      });
      this.$bus.$emit('calendar-layout-reload-needed');
      this.$bus.$emit('reservation-details-popup-reload-needed');
    },
    finishUnblockProcess () {
      this.unblockInProgress = false;
      this.$bus.$emit('notification-display', {
        type: 'success',
        message: this.$t('reservationStatusChange.dateUnblocked')
      });
      this.$bus.$emit('calendar-layout-reload-needed');
      this.$bus.$emit('reservation-details-popup-reload-needed');
      this.$bus.$emit('blocked-termins-list-reload-needed');
    },
    notifyPeople (people) {
      this.$http.post('/panel/reservations/send-reserve-list', {
        id: this.reservationData.id
      }).then(response => {
        this.finishRejectionProcess(true);
      }).catch(error => {
        ErrorUtils.handleSubmitError(error, '/panel/reservations/send-reserve-list', this.$router, this.$bus, this.notifyPeople.bind(this, people));
        this.finishRejectionProcess();
      });
    },
    updateInquiriesList (newStatus) {
      this.$store.commit('global/setWaitingInquiryStatus', {
        inquiryID: this.reservationData.id,
        status: newStatus
      });

      this.reservationData.status = newStatus;

      if (this.reservationData.cart_id > 0) {
        if (!this.cartIsWaitingForDecision(this.reservationData.cart_id)) {
          this.$store.commit('global/removeInquiriesCart', this.reservationData.cart_id);
        }
      } else {
        this.$store.commit('global/removeInquiry', this.reservationData.id);
        this.$bus.$emit('dashboard-reservations-list-reload-needed');
      }

      this.$bus.$emit('update-favicon');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mixins/ReservationStatusChange.vue